/**
 * Common query options for brand strategy queries to prevent unnecessary refetches
 * and improve performance.
 */
export const createStableQueryOptions = () => ({
  staleTime: 5 * 60 * 1000, // 5 minutes
  gcTime: 10 * 60 * 1000, // 10 minutes
  refetchOnWindowFocus: false,
  refetchOnMount: false,
});

/**
 * Common query options for brand strategy queries with custom stale time.
 *
 * @param staleTimeMinutes - Custom stale time in minutes (default: 5)
 * @param gcTimeMinutes - Custom garbage collection time in minutes (default: 10)
 * @returns Query options object
 */
export const createCustomStableQueryOptions = (
  staleTimeMinutes: number = 5,
  gcTimeMinutes: number = 10
) => ({
  staleTime: staleTimeMinutes * 60 * 1000,
  gcTime: gcTimeMinutes * 60 * 1000,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
});
